import { QueryKeys } from "@/constants/Query";
import axiosInstance from "@/lib/axios";
import { useQuery } from "@tanstack/react-query";

export interface AsyncMessageInboxResponse {
  asyncMessages: AsyncMessageItem[];
  pagination: null; // Currently not used
}

export interface AsyncMessageItem {
  message: AsyncMessageMessageData;
  patient: AsyncMessagePatientData;
  encounter: AsyncMessageEncounterData;
}

export interface AsyncMessageMessageData {
  archived: boolean;
  messageBody: string;
  notificationId: number;
  receivedAt: string;
  slaEndedAt: string | null;
  unread: boolean;
}

export interface AsyncMessagePatientData {
  addressState: string;
  administrativeGender: string;
  age: number;
  dob: string;
  genderIdentity: string;
  id: string;
  isPeds: boolean;
  nameFirst: string;
  nameLast: string;
  partnerUids: string[];
  preferredPartnerUid?: string | null;
}

export interface AsyncMessageEncounterData {
  ownAsyncEncounterId?: string;
}

export const useAsyncMessageInbox = (enabled = true) => {
  return useQuery({
    queryFn: async () => {
      const response = await axiosInstance.get<AsyncMessageInboxResponse>(
        "/new-api/async-message-dashboard/inbox",
      );

      return response.data;
    },
    queryKey: QueryKeys.Provider.AsyncMessageDashboard.INBOX,
    enabled,
  });
};
